import HeadTittle from "../../../components/HeadTittle";
import React from "react";
import {ApprovalTrackerApp} from "./Functionality/ApprovalTrackerApp";
import Subtitle from "../../../components/Header/Subtitle";
import CustomUserChip from "../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../Helpers/PositionModel";
import {
    InfoChip,
} from "../../../components/buttons/IconButtons";
import CustomChip from "../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../enums/statusEnum";
import LevelCard from "./SubComponents/LevelCard";
import GeneralCommentModal from "./Modal/GeneralCommentModal";
import DivContainerBody from "../../../components/DivContainerBody";
import {EMPTY_VALUES} from "../../../Apis/functions";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const ApprovalTracker = ({details}) => {

    const {
        t,
        genericCommentModals,
        setShowApprove,
        setShowDenied,
        setShowIssueComment,
        setRow,
        setModified,
        modified,
        getApprovalTrackerProgress,
        user,
        module,
        isOverdue,
        handleOnBack,
        isCanceled,
        currentStatus,
        bannerProps
    } = ApprovalTrackerApp()

    return (
        <>
            <HeadTittle name={details ? 'approval_manager'  : 'approval_tracker'}
                        onBack={handleOnBack}
            />
            <DivContainerBody>
                { bannerProps &&
                    <CustomUserChip
                        className={`mt-0 ${bannerProps.className} justify-content-start d-flex my-3`}
                        name={bannerProps.name}
                        classNameIcon={bannerProps.classNameIcon}
                        Icon={InfoChip}
                        showAvatar={true}
                        variant="large"
                        iconPosition={POSITION_MODEL.LEFT}
                    />
                }

                <div className={"border-radius-8px border-full-shades-300 p-16px"}>
                    <div className={"d-flex justify-content-between align-items-center mb-24px"}>
                        <Subtitle name={'request_status'}/>
                        <CustomChip
                            variant={'large'}
                            background={statusColor[currentStatus]}
                            fontColor={statusFontColor[currentStatus]}
                            borderColor={statusBorderColor[currentStatus]}
                            legend={t(status[currentStatus]) || EMPTY_VALUES.DEFAULT}
                        />
                    </div>
                    {
                        getApprovalTrackerProgress?.levels?.map((item, index) => {
                            let disabled = true;

                            if(  isCanceled || ( isOverdue && (getApprovalTrackerProgress?.overallStatus?.id !== STATUS_MODEL.APPROVED &&
                                getApprovalTrackerProgress?.overallStatus?.id !== STATUS_MODEL.DENIED))){
                                disabled = true;
                            }else{
                                if (index === 0) {
                                    disabled = false;
                                } else {
                                    const prevLevel = getApprovalTrackerProgress.levels[index - 1];
                                    if (prevLevel.levelStatusId === STATUS_MODEL.APPROVED) {
                                        disabled = false;
                                    }
                                }
                            }

                            const responded = item.approvers?.filter(a =>
                                Number(a.statusId) === STATUS_MODEL.APPROVED ||
                                Number(a.statusId) === STATUS_MODEL.DENIED
                            ).length || 0;

                            const pending = item.approvers?.filter(a => Number(a.statusId) === STATUS_MODEL.DENIED).length >= 1 ?
                                0 : item.approvers?.filter(a => Number(a.statusId) !== STATUS_MODEL.APPROVED).length || 0;


                            return (
                                <LevelCard
                                    item={item}
                                    t={t}
                                    disabled={disabled}
                                    row={item?.levelId}
                                    setRow={setRow}
                                    setShowApprove={setShowApprove}
                                    setShowDenied={setShowDenied}
                                    setShowIssueComment={setShowIssueComment}
                                    responded={responded}
                                    pending={pending}
                                    user={user}
                                    details={details}
                                    module={module}
                                />
                            );
                        })
                    }
                </div>
                {genericCommentModals.map(({ show,
                                               setter,
                                               title,
                                               setRow,
                                               row,
                                               status,
                                               module,endPoint}, idx) => {
                        return (
                            <>
                                <GeneralCommentModal
                                    show={show}
                                    setRow={setRow}
                                    onHide={() => setter(false)}
                                    title={title}
                                    setModified={setModified}
                                    modified={modified}
                                    row={row}
                                    status={status}
                                    module={module}
                                    endPoint={endPoint}
                                />
                            </>
                        )
                    }
                )}
            </DivContainerBody>

        </>
    )
}

export default ApprovalTracker

